import { Trans } from '@lingui/react/macro';
import { Link } from '@tanstack/react-router';
import { buttonVariants } from '@pantry/ui';

export function NotFoundComponent() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-muted px-4">
      <div className="text-center">
        <p className="text-sm font-medium text-primary">404</p>
        <h1 className="mt-2 text-3xl font-bold text-foreground">
          <Trans>Page not found</Trans>
        </h1>
        <p className="mt-2 text-muted-foreground">
          <Trans>Sorry, we could not find the page you are looking for.</Trans>
        </p>
        <div className="mt-6">
          <Link to="/dashboard" className={buttonVariants()}>
            <Trans>Go to Dashboard</Trans>
          </Link>
        </div>
      </div>
    </div>
  );
}
